import {AppBar, Avatar, Box, Container, Toolbar} from "@mui/material";
import React from "react";
import {useNavigate} from "react-router-dom";

const LandingHeader = () => {
    const navigate = useNavigate();

    return (
        <>
            <AppBar
                position="sticky"
                sx={{
                    backgroundColor: "rgba(0, 0, 0, 0.0)", // Semi-transparent black
                    backdropFilter: "blur(10px)", // Apply blur effect
                    WebkitBackdropFilter: "blur(10px)", // Safari support
                }}
            >
                <Container>
                    <Toolbar
                        sx={{
                            height: '50px',
                            maxHeight: '50px !important',
                            minHeight: '50px !important',
                            display: 'flex',
                            justifyContent: 'space-between'
                        }}>
                        <Box
                            sx={{
                                cursor: 'pointer'
                            }}
                            onClick={() => navigate('/')}
                        >
                            <Avatar
                                src="/images/konstantinos.jpg"
                                alt="Konstantinos Panteli"
                                sx={{
                                    width: '40px',
                                    height: '40px',
                                    border: "2px solid rgba(255, 215, 0, 0.3)", // Subtle Gold Border
                                }}
                            />
                        </Box>
                        <Box sx={{display: 'flex', height: '100%', gap:'20px'}}>
                            <p style={{
                                fontSize: '14px',
                                fontWeight: 'bold',
                                cursor: 'pointer'
                            }}
                               onClick={() => navigate('/projects')}
                            >
                                Projects
                            </p>
                            <p style={{
                                fontSize: '14px',
                                fontWeight: 'bold',
                                cursor: 'pointer'
                            }}
                               onClick={() => navigate('/experience')}
                            >
                                Experience
                            </p>
                            <p style={{
                                fontSize: '14px',
                                fontWeight: 'bold',
                                cursor: 'pointer'
                            }}
                               onClick={() => navigate('/education')}
                            >
                                Education
                            </p>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
        </>
    )
}

export default LandingHeader;
